import { Box, Skeleton, Typography } from "@mui/material";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PauseCircleRoundedIcon from "@mui/icons-material/PauseCircleRounded";

const cardConfigs = [
  {
    title: "Total Packages",
    key: "total",
    bg: "#EEF3FB",
    accent: "#2456C7",
    iconBg: "#DCE7F9",
    icon: <Inventory2RoundedIcon fontSize="small" />,
  },
  {
    title: "Active Packages",
    key: "active",
    bg: "#EDF7F1",
    accent: "#1D7E45",
    iconBg: "#D9F0E3",
    icon: <CheckCircleRoundedIcon fontSize="small" />,
  },
  {
    title: "Inactive Packages",
    key: "inactive",
    bg: "#F9F2E9",
    accent: "#B44A0B",
    iconBg: "#F3E3CD",
    icon: <PauseCircleRoundedIcon fontSize="small" />,
  },
];

export default function FirmwarePackageCards({ data = [], loading }) {
  const total = data.length;
  const active = data.filter((p) => p.is_active).length;
  const inactive = total - active;
  const counts = { total, active, inactive };

  return (
   <Box
  display="grid"
  gridTemplateColumns={{
    xs: "1fr",
    sm: "1fr 1fr",
    md: "1fr 1fr 1fr",
    lg: "1fr 1fr 1fr",
  }}
  gap={2}
  mb={1}
>
  {cardConfigs.map((card) => (
    <Box
      key={card.key}
      sx={{
        borderRadius: 4,
        p: 2,
        backgroundColor: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.15)",
        backdropFilter: "blur(12px)",
        color: "#fff",
        transition: "all 0.25s ease",

        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
        },
      }}
    >
      {/* 🔥 MAIN FIX: flex row */}
      <Box display="flex" alignItems="center">
        
        {/* ICON */}
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            background: card.iconBg,
            color: card.accent,
            mr: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {card.icon}
        </Box>

        {/* TEXT */}
        <Box>
          <Typography variant="body2" color="#fff" fontWeight={500}>
            {card.title}
          </Typography>

          {loading ? (
            <Skeleton width={40} height={30} />
          ) : (
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              {counts[card.key]}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  ))}
</Box>
  );
}
